module.exports = __webpack_public_path__ + "img/logo_white.c7f01a55.png";